import { render, staticRenderFns } from "./PlatformTag.vue?vue&type=template&id=652cd544&"
import script from "./PlatformTag.vue?vue&type=script&lang=js&"
export * from "./PlatformTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports